import { createRouter, createWebHistory } from 'vue-router'
import MainView from '../views/MainView.vue'
import EmbedView from '../views/EmbedView.vue'
import ContractEdit from '../components/ContractEdit.vue'
import CustomerEdit from '../components/CustomerEdit.vue'
import ContactEdit from '../components/ContactEdit.vue'
import PollEdit from '../components/PollEdit.vue'
import ProjectEdit from '../components/ProjectEdit.vue'
import DistributionLists from '../components/DistributionLists.vue'
const routes = [
  {
    path: '/',
    name: 'Home',
    component: MainView
  },
  {
    path: '/attendance',
    name: 'Anwesenheit',
    component: MainView
  },
  {
    path: '/mealplanning',
    name: 'Essensplanung',
    component: MainView
  },
  {
    path: '/contracts',
    name: 'Verträge',
    component: MainView
  },
  {
    path: '/customers',
    name: 'Kunden',
    component: MainView
  },
  {
    path: '/projects',
    name: 'Projekte',
    component: MainView
  },
  {
    path: '/export',
    name: 'Exporte',
    component: MainView
  },
  {
    path: '/contracts/:id',
    name: 'ContractEdit',
    component: ContractEdit
  },
  {
    path: '/customers/:id',
    name: 'CustomerEdit',
    component: CustomerEdit
  },
  {
    path: '/contacts',
    name: 'Kontakte',
    component: MainView
  },
  {
    path: '/contacts/:id',
    name: 'ContactEdit',
    component: ContactEdit
  },
  {
    path: '/polls',
    name: 'Umfragen',
    component: MainView
  },
  {
    path: '/polls/:id',
    name: 'PollEdit',
    component: PollEdit
  },
  {
    path: '/projects/:id',
    name: 'ProjectEdit',
    component: ProjectEdit
  },
  {
    path: '/distribution-lists',
    name: 'Verteiler',
    component: MainView
  },
  {
    path: '/employees',
    name: 'Mitarbeiter',
    component: MainView
  },
  {
    path: '/announcements',
    name: 'Ankündigungen',
    component: MainView
  },
  {
    path: '/account-help',
    name: 'Accounthilfe',
    component: MainView
  },
  {
    path: '/permissions',
    name: 'Berechtigungen',
    component: MainView
  },
  {
    path: '/import',
    name: 'Import',
    component: MainView
  },
  {
    path: '/maintenance',
    name: 'Wartungsmodus',
    component: MainView
  },
  {
    path: '/embed',
    name: "Einbettung",
    component: EmbedView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
